(function(){
  function init(root){
    if(!root || root.dataset.fmB6MobileReady==='true') return;
    root.dataset.fmB6MobileReady='true';

    var desktop=window.matchMedia('(min-width:1024px)');
    var reduceMotion=window.matchMedia('(prefers-reduced-motion:reduce)');
    var topSections=Array.prototype.slice.call(root.querySelectorAll(':scope > .fm-b6-mobile-nav__section'));
    var categories=Array.prototype.slice.call(root.querySelectorAll('.fm-b6-mobile-nav__category'));
    var panel=root.closest('.mobile-nav-panel');
    var drawer=root.closest('[data-mobile-nav]');
    var menuToggle=document.querySelector('[data-menu-toggle]');
    var closeButton=drawer ? drawer.querySelector('[data-mobile-nav-close]') : null;
    var resetTimer=null;

    function resetDrawerScroll(){
      if(!panel) return;

      if(resetTimer){
        window.clearTimeout(resetTimer);
        resetTimer=null;
      }

      panel.scrollTop=0;

      window.requestAnimationFrame(function(){
        panel.scrollTop=0;
      });

      resetTimer=window.setTimeout(function(){
        panel.scrollTop=0;
        resetTimer=null;
      },80);
    }

    function bringIntoView(details){
      var summary=details && details.querySelector(':scope > summary');
      if(!summary) return;
      window.requestAnimationFrame(function(){
        summary.scrollIntoView({
          block:'nearest',
          inline:'nearest',
          behavior:reduceMotion.matches?'auto':'smooth'
        });
      });
    }

    function closeNested(section){
      section.querySelectorAll('.fm-b6-mobile-nav__category[open]').forEach(function(item){
        item.removeAttribute('open');
      });
    }

    function resetNavigationState(){
      topSections.forEach(function(section){
        section.removeAttribute('open');
        closeNested(section);
      });
      resetDrawerScroll();
    }

    topSections.forEach(function(section){
      section.addEventListener('toggle',function(){
        if(section.open){
          topSections.forEach(function(other){
            if(other!==section && other.open){
              other.removeAttribute('open');
              closeNested(other);
            }
          });
          bringIntoView(section);
        }else{
          closeNested(section);
        }
      });
    });

    categories.forEach(function(category){
      category.addEventListener('toggle',function(){
        if(!category.open) return;
        var container=category.parentElement;
        if(container){
          Array.prototype.slice.call(container.children).forEach(function(sibling){
            if(
              sibling!==category &&
              sibling.matches &&
              sibling.matches('.fm-b6-mobile-nav__category[open]')
            ){
              sibling.removeAttribute('open');
            }
          });
        }
        bringIntoView(category);
      });
    });

    if(menuToggle){
      menuToggle.addEventListener('click',resetNavigationState);
    }

    if(closeButton){
      closeButton.addEventListener('click',resetNavigationState);
    }

    function onBreakpoint(){
      if(desktop.matches){
        resetNavigationState();
      }
    }

    if(desktop.addEventListener) desktop.addEventListener('change',onBreakpoint);
    else desktop.addListener(onBreakpoint);
  }

  function boot(scope){
    (scope||document).querySelectorAll('[data-fm-b6-mobile-nav]').forEach(init);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){boot(document);});
  }else{
    boot(document);
  }

  document.addEventListener('shopify:section:load',function(event){boot(event.target);});
})();